<template>
<!-- 头部组件 -->
  <div id="header">
    <div class="hea_1">
      <!--<p class="hea_p_1"></p>-->
      <!--<p class="hea_p_2">重庆警察学院</p>-->
      <p class="hea_p_3">地下管网可视化系统</p>
      <div class="hea_en">
        <!-- 这是那几个小点 -->
        <ul class="hea_2">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <div class="hea_3">
          <!--<p class="hea_p_4">CHONGQING POLICE COLLEGE&nbsp;</p>-->
          <p class="hea_p_5">VISUALIZATION OF UNDERGROUND PIPE NETWORKS</p>
        </div>
      </div>
      
      
    </div>
    <!-- 滑块调节地面透明度 -->
    <my-slider class="slider"></my-slider>
    <div class="hea_right">
      <!-- 控制模型的按钮 -->
      <div class="but">
        <p class="but_pic_1"></p>
        <p class="but_all" @click="change_in" v-preventReClick>.全景总瞰.</p>
        <p class="but_pic_2"></p>
        <p class="but_all" @click="change_out" v-preventReClick>.地下管网.</p>
        <p class="but_pic_3"></p>
      </div>

      <div class="now_time">
        <!-- 显示的时间 -->
        <div class="time">
          <p>{{ data.hours }}:{{ data.minutes }}:{{ data.seconds }}</p>
        </div>
        <!-- 显示的日期 -->
        <div class="data">
          <p>{{ week | weekfilter }}</p>
          <p>{{ data.years }}-{{ data.months }}-{{ data.date }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("zh-cn");
//import axios from "axios";
import MySlider from '@/components/com/MySlider.vue'
export default {
  data() {
    return {
      data: [],
      week: "",
      pagetype: true,
      shchoolName: "",
    };
  },
  components: {
    MySlider
    // MySlider
  },
  mounted() {
    // 调用时间的方法，并0.1秒调用一次
    this.getTime();
    setInterval(()=>{
      this.getTime();
    }, 100);

    //post传递的参数
    var params = new URLSearchParams();
    params.append("deptId", "892");
    params.append("checkCode", "3F55CAEAEAA1261CEFB7369CB6987DDB");
//  axios.post("/api/data/getDept", params)
//    .then((res) => {
        // console.log(res.data.data.resData)
        // console.log(res.data.data.resData[0].dept_name)
        this.shchoolName = "";
//    })
//    .catch((error) => {
//      console.log(error);
//    });
  },
  methods: {
    getTime() {
      //使用moment库获取时间
      this.month = moment().month(); // [years, months, date, hours, minutes, seconds, milliseconds]
      var data_t = moment().toObject();
      this.week = moment().weekday();
      this.$store.state.hours=data_t.hours;   //将小时获取，用于判断警告出现的时间
      // 对拿到的时间进行一个格式的调整
      data_t.months = data_t.months+1;
      if (data_t.months < 10) {
        data_t.months = "0" + `${data_t.months}`;
      }
      if (data_t.date < 10) {
        data_t.date = `0${data_t.date}`;
      }
      if (data_t.hours < 10) {
        data_t.hours = `0${data_t.hours}`;
      }
      if (data_t.minutes < 10) {
        data_t.minutes = `0${data_t.minutes}`;
      }
      if (data_t.seconds < 10) {
        data_t.seconds = `0${data_t.seconds}`;
      }
      this.data = data_t;
      // console.log(this.data)
    },
    // 切换管道与建筑全景
    change_in() {
      // MMAPI.overplace(this.pagetype)
      var i = 2;
      document.getElementById("iframe").contentWindow.MMAPI.overplace(i);
      this.$store.commit("changewatchshow_3");
      this.$store.commit("changefamenshow_2");
      this.$store.commit("changexiaofangshow_2");
      this.$store.commit("changegive_water_1");
      this.$store.commit("changegive_xiaofang_1");
      this.$store.commit("changepressbut_1");
      
      this.$store.commit("environmentchange_2");     //点击建筑全景会调用environmentchange_1改变environmentchange的状态为false，只有为false状态下，调节透明度的按钮才会可用
      this.$store.commit("tumingvaluechange"); //透明度数值还原
      setTimeout(()=>{
          this.$store.commit("changebutshowfalse");
          this.$store.commit('change_shebei_true');
          document.getElementById('shebei_but').className = "but_3"
        },100)
    },
    change_out() {
      var i = 1;
      document.getElementById("iframe").contentWindow.MMAPI.overplace(i);
      this.$store.commit("changegive_water_1");
      this.$store.commit("changegive_xiaofang_1");
      this.$store.commit("changepressbut_1");
      this.$store.commit("environmentchange_1");
      this.$store.commit("tumingvaluechange"); //透明度数值还原
      setTimeout(()=>{
          this.$store.commit("changebutshowfalse");
          this.$store.commit('change_shebei_true');
          document.getElementById('shebei_but').className = "but_3"
        },100)
    },
  },

  //过滤转换星期的格式星期
  filters: {
    weekfilter(week) {
      if (week === 0) {
        return "星期一";
      } else if (week === 1) {
        return "星期二";
      } else if (week === 2) {
        return "星期三";
      } else if (week === 3) {
        return "星期四";
      } else if (week === 4) {
        return "星期五";
      } else if (week === 5) {
        return "星期六";
      } else if (week === 6) {
        return "星期天";
      }
    },
  },
};
</script>

<style scoped>
#header {
  display: flex;
  justify-content: space-evenly;
  overflow: hidden;
}
.hea_1 {
  flex: 2;
  display: flex;
  text-align: center;
  line-height: 5vh;
  font-size: 28px;
}
.hea_p_1 {
  width: 1.19vw;
  height: 5vh;
  background: url("@/assets/pengshui_2.png") no-repeat center center;
  margin-right: 0.52vw;
  line-height: 5vh;
}
.hea_p_2 {
  color: #649cff;
  height: 5vh;
}
.hea_p_3 {
  color: #ffffff;
  height: 5vh;
  -o-user-select: none;
	-moz-user-select: none; /*/火狐 firefox/*/
	-webkit-user-select: none; /*/webkit浏览器/*/
	-ms-user-select: none; /*/IE10+/*/
	-khtml-user-select: none; 
	user-select: none;
}
.hea_p_4 {
  color: #24448f;
  height: 3vh;
  text-align: center;
  line-height: 2vh;
}
.hea_p_5 {
  color: #ffffff;
  height: 3vh;
  text-align: center;
  line-height: 2vh;
  -o-user-select: none;
	-moz-user-select: none; /*/火狐 firefox/*/
	-webkit-user-select: none; /*/webkit浏览器/*/
	-ms-user-select: none; /*/IE10+/*/
	-khtml-user-select: none; 
	user-select: none;
}
.hea_2,
.hea_3 {
  display: flex;
  align-items: flex-end;
  font-size: 12px;
  margin-left: 0.52vw;
}
.hea_en {
  flex: 1;
}
.hea_2 {
  height: 2.1vh;
  /* line-height: 2vh; */
}
.hea_2 li {
  width: 5px;
  height: 5px;
  background: #ffffff;
  border-radius: 5px;
  margin-right: 1vw;
  /* transform: translateY(1.5vh); */
}
.hea_right {
  flex: 1;
  display: flex;
  justify-content: space-around;
  text-align: center;
  line-height: 5vh;
}
.slider {
  flex: 0.32;
}
/* .hea_right button {
  height: 2.5vh !important; 
  line-height: 2.5vh;
  color: #ffffff;
  border: 2px solid #172f71;
} */
.but {
  /* width: 8vw; */
  flex: 4;
  margin-right: 2vw;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.but_all {
  height: 2.5vh !important;
  line-height: 2.5vh;
  background: #24448f;
  border: 2px solid #172f71;
  cursor: pointer;
  -o-user-select: none;
	-moz-user-select: none; /*/火狐 firefox/*/
	-webkit-user-select: none; /*/webkit浏览器/*/
	-ms-user-select: none; /*/IE10+/*/
	-khtml-user-select: none; 
	user-select: none;
}
.but_all_stop{
  height: 2.5vh !important;
  line-height: 2.5vh;
  background: #24448f;
  border: 2px solid #172f71;
  cursor: pointer;
  pointer-events: none;
}
.now_time {
  flex: 3.2;
  color: #ffffff;
  margin-right: 0.52vw;
  display: flex;
}
.time {
  flex: 1.35;
  margin-right: 0.52vw;
  font-size: 24px;
  color: #649cff;
  display: flex;
}
.time p {
  flex: 1;
  -o-user-select: none;
	-moz-user-select: none; /*/火狐 firefox/*/
	-webkit-user-select: none; /*/webkit浏览器/*/
	-ms-user-select: none; /*/IE10+/*/
	-khtml-user-select: none; 
	user-select: none;
}
.data {
  flex: 1;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.data p {
  height: 2.5vh;
  line-height: 2.5vh;
  font-size: 12px;
  -o-user-select: none;
	-moz-user-select: none; /*/火狐 firefox/*/
	-webkit-user-select: none; /*/webkit浏览器/*/
	-ms-user-select: none; /*/IE10+/*/
	-khtml-user-select: none; 
	user-select: none;
}
.data :nth-child(1) {
  line-height: 3.5vh;
}
.data :nth-child(2) {
  line-height: 2vh;
}
.but_pic_1 {
  flex: 1;
  background: url("@/assets/pengshui_3.png") no-repeat center center;
  /* width: 50px; */
  height: 5vh;
}
.but_pic_2 {
  flex: 1;
  background: url("@/assets/pengshui_4.png") no-repeat center center;
  /* width: 50px; */
  height: 5vh;
}
.but_pic_3 {
  background: url("@/assets/pengshui_5.png") no-repeat center center;
  width: 2.6vw;
  height: 5vh;
}
</style>